<template>
    <div class="screen3 flex p-3">
      <img :src="imagePath(selectedGame.src)" :alt="selectedGame.name" class="game-image selected mr-4">
      <div class="flex flex-col justify-between w-full text-left">
        <div>
          <p class="selected-game-label ">JOGO SELECIONADO</p>
          <div class="flex items-center justify-between mb-4 line-title">
            <p class="selected-game-name">{{ selectedGame.name }}</p>
            <button @click="$emit('previous-screen')" class="text-white text-[9px] change-button rounded-full flex p-1">
              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path d="M2.9423 6.44918C2.9423 4.68952 4.36755 3.26428 6.1272 3.26428C6.66597 3.26428 7.17026 3.39964 7.61614 3.63321L8.39115 2.8582C7.73292 2.4468 6.96058 2.20264 6.1272 2.20264C3.78098 2.20264 1.88066 4.10295 1.88066 6.44918H0.288208L2.41147 8.57244L4.53473 6.44918H2.9423Z" fill="white" />
                  <path d="M9.84294 4.32587L7.71968 6.44913H9.31213C9.31213 8.20878 7.88688 9.63403 6.12722 9.63403C5.58845 9.63403 5.08417 9.49867 4.63828 9.2651L3.86328 10.0401C4.52149 10.4515 5.29383 10.6957 6.12722 10.6957C8.47343 10.6957 10.3738 8.79535 10.3738 6.44913H11.9662L9.84294 4.32587Z" fill="white" />
                </g>
              </svg>
              &nbsp;
              Mudar
            </button>
          </div>
          <div class="custom-bg-setup mb-4 p-2">
            <div class="flex items-center justify-between">
              <span class="font-bold custom-bg-setup-font">Configure seu jogo</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.51933 1.43465C9.27266 1.33331 8.95933 1.33331 8.33333 1.33331C7.70733 1.33331 7.39466 1.33331 7.14733 1.43465C6.81896 1.56945 6.55758 1.82916 6.42066 2.15665C6.358 2.30531 6.334 2.47931 6.324 2.73198C6.31955 2.91505 6.26849 3.09396 6.17563 3.25179C6.08277 3.40963 5.95119 3.54117 5.79333 3.63398C5.63249 3.72338 5.45169 3.77074 5.26768 3.77168C5.08367 3.77261 4.9024 3.72708 4.74066 3.63931C4.51533 3.52065 4.352 3.45531 4.19066 3.43398C3.8377 3.38764 3.48071 3.48251 3.19733 3.69798C2.98533 3.85931 2.82866 4.12865 2.516 4.66665C2.20266 5.20465 2.04666 5.47331 2.01133 5.73665C1.96466 6.08731 2.06066 6.44198 2.278 6.72265C2.37666 6.85065 2.516 6.95798 2.73133 7.09265C3.04933 7.29065 3.25333 7.62798 3.25333 7.99998C3.25333 8.37198 3.04933 8.70931 2.732 8.90665C2.516 9.04198 2.37666 9.14931 2.27733 9.27731C2.17005 9.41594 2.09131 9.57445 2.04565 9.74369C2 9.91293 1.98833 10.0895 2.01133 10.2633C2.04666 10.526 2.20266 10.7953 2.516 11.3333C2.82933 11.8713 2.98533 12.14 3.19733 12.302C3.48 12.5173 3.83733 12.612 4.19066 12.566C4.352 12.5446 4.51533 12.4793 4.74066 12.3606C4.90248 12.2728 5.08387 12.2272 5.26801 12.2281C5.45216 12.229 5.63308 12.2765 5.794 12.366C6.118 12.5526 6.31 12.896 6.324 13.268C6.334 13.5213 6.358 13.6946 6.42066 13.8433C6.55666 14.17 6.818 14.43 7.14733 14.5653C7.394 14.6666 7.70733 14.6666 8.33333 14.6666C8.95933 14.6666 9.27266 14.6666 9.51933 14.5653C9.8477 14.4305 10.1091 14.1708 10.246 13.8433C10.3087 13.6946 10.3327 13.5213 10.3427 13.268C10.356 12.896 10.5487 12.552 10.8733 12.366C11.0342 12.2766 11.215 12.2292 11.399 12.2283C11.583 12.2274 11.7643 12.2729 11.926 12.3606C12.1513 12.4793 12.3147 12.5446 12.476 12.566C12.8293 12.6126 13.1867 12.5173 13.4693 12.302C13.6813 12.1406 13.838 11.8713 14.1507 11.3333C14.464 10.7953 14.62 10.5266 14.6553 10.2633C14.6782 10.0895 14.6665 9.91286 14.6207 9.74362C14.5749 9.57438 14.4961 9.41589 14.3887 9.27731C14.29 9.14931 14.1507 9.04198 13.9353 8.90731C13.6173 8.70931 13.4133 8.37198 13.4133 7.99998C13.4133 7.62798 13.6173 7.29065 13.9347 7.09331C14.1507 6.95798 14.29 6.85065 14.3893 6.72265C14.4966 6.58402 14.5754 6.42551 14.621 6.25627C14.6667 6.08703 14.6783 5.91042 14.6553 5.73665C14.62 5.47398 14.464 5.20465 14.1507 4.66665C13.8373 4.12865 13.6813 3.85998 13.4693 3.69798C13.1859 3.48251 12.829 3.38764 12.476 3.43398C12.3147 3.45531 12.1513 3.52065 11.926 3.63931C11.7642 3.7272 11.5828 3.77279 11.3986 3.77186C11.2145 3.77093 11.0336 3.7235 10.8727 3.63398C10.7149 3.54109 10.5835 3.40951 10.4907 3.25168C10.398 3.09385 10.347 2.91498 10.3427 2.73198C10.3327 2.47865 10.3087 2.30531 10.246 2.15665C10.1782 1.99447 10.0792 1.84723 9.95449 1.72335C9.82981 1.59947 9.68194 1.50136 9.51933 1.43465ZM8.33333 9.99998C9.44666 9.99998 10.3487 9.10465 10.3487 7.99998C10.3487 6.89531 9.446 5.99998 8.33333 5.99998C7.22 5.99998 6.318 6.89531 6.318 7.99998C6.318 9.10465 7.22066 9.99998 8.33333 9.99998Z" fill="#2555FF" />
              </svg>
            </div>
          </div>
          <div class="settings-content bg-[#FFFFFF0D] p-2 rounded-lg">
            <div class="flex items-center mb-4">
              <CustomCheckbox :model-value="checked1" @update:model-value="updateChecked('checked1', $event)" class="mr-2" />
              <span class="ml-3 text-white">Soltando mais cartinhas</span>
            </div>
            <div class="flex items-center mb-4">
              <CustomCheckbox :model-value="checked2" @update:model-value="updateChecked('checked2', $event)" class="mr-2" />
              <span class="ml-3 text-white">Multiplicador maior</span>
            </div>
            <div class="flex items-center mb-0">
              <CustomCheckbox :model-value="checked3" @update:model-value="updateChecked('checked3', $event)" class="mr-2" />
              <span class="ml-3 text-white">Super mega ganho</span>
            </div>
          </div>
          <div class="mt-4">
            <p class="text-[15px] text-white font-bold mb-1">Descrição</p>
            <p class="text-[9px] text-gray-500 text-white">Alavanque seu game usando o boost para games selecionados com o Unlocker de ganhos, que te garante 98% de ganhos!</p>
          </div>
          <button @click="proceedToNextScreen" class="custom-button w-full py-2 rounded hover:bg-blue-600 mt-4">
            Comece agora
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-2">
              <path d="M3.15004 11.6667L2.33337 10.85L9.10004 4.08335H5.25004V2.91669H11.0834V8.75002H9.91671V4.90002L3.15004 11.6667Z" fill="white" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import CustomCheckbox from '@/components/CustomCheckbox.vue';

export default {
  name: 'ScreenSettings',
  components: {
    CustomCheckbox
  },
  props: ['selectedGame', 'checked1', 'checked2', 'checked3'],
  data() {
    return {
      isActive: true, // This will control the toggle state
    };
  },
  methods: {
    imagePath(imageName) {
      return require(`@/assets/images/${imageName}`);
    },
    saveSettings() {
      console.log('Saving settings');
      this.$emit('save-settings');
    },
    proceedToNextScreen() {
      this.$emit('next-screen');
    },
    expandGame() {
      this.$emit('expand-game', this.selectedGame);
    },
    updateChecked(key, value) {
      console.log('Updating checked', key, value);
      this.$emit('update-checked', {
        checked1: key === 'checked1' ? value : this.checked1,
        checked2: key === 'checked2' ? value : this.checked2,
        checked3: key === 'checked3' ? value : this.checked3,
        isActive: true,
      });
    }
  }
};
</script>
  
  <style scoped>
  .settings-content {
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    color: white;
  }
  .line-title{
    margin-top: -8px;
  }
  .custom-bg-setup {
    background-color: #2555FF17;
    border: 0.5px solid #2555FF45;
    border-radius: 6px;
  }
  
  .custom-bg-setup-font {
    font-size: 12px;
    font-weight: 600;
    line-height: 12px;
    text-align: left;
    color: white;

  }
  
  .custom-bg-checkbox {
    background-color: #FFFFFF0D;
  }
  
  .selected-game-label {
    font-size: 7px;
    color: #9ca3af; /* Cor cinza para diferenciar */
    margin-bottom: 4px;
  }
  
  .selected-game-name {
    font-size: 20px;
    font-weight: bold;
    color: white;
  }
  
  .config-label {
    font-size: 12px;
    color: white;
  }
  
  .change-button {
    background-color: #2555FF;
    color: white;
    border-radius: 900px;
    font-size: 9px;
  }
  
  .custom-button {
    background-color: #2555FF;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .game-image {
    height: auto;
    width: 100%;
    max-width: 82px;
    border-radius: 10px;
    object-fit: cover;
    filter: grayscale(100%);
    transition: filter 0.3s;
  }
  
  .game-image.selected {
    filter: none;
  }
  
  .third-screen-text {
    font-size: 12px;
    line-height: 21.78px;
    color: white;
  }
  </style>
  